import { render, staticRenderFns } from "./ManageMessagePushTools.vue?vue&type=template&id=0dd2d748&"
import script from "./ManageMessagePushTools.vue?vue&type=script&lang=js&"
export * from "./ManageMessagePushTools.vue?vue&type=script&lang=js&"
import style0 from "./ManageMessagePushTools.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VApp,VBtn})
